import {Jobbranche} from "../api";

export const JobbrancheValues: Jobbranche[] = [
    'Informationstechnologie (IT)',
    'Gesundheitswesen',
    'Finanzen und Versicherungen',
    'Industrie und Produktion',
    'Bauwesen und Architektur',
    'Handel',
    'Logistik und Transport',
    'Bildung und Forschung',
    'Marketing und Werbung',
    'Tourismus und Gastgewerbe',
    'Medien und Unterhaltung',
    'Recht und Beratung',
    'Öffentlicher Sektor und Verwaltung',
    'Energie und Umwelt',
    'Personal',
    'Andere Branche',
];